<template>
  <div>
    <div v-if="subAccountList.length">
      <div class="title">我的附属户</div>
      <div class="content">
        <div class="item" v-for="(item, index) in subAccountList" :key="index">
          <div class="logo">
            <img src="@/assets/hk.png" alt="" v-if="item.channelCode === '001' || item.channelCode === '003'">
          </div>
          <div class="bank">
            <p class="no">{{item.exAccountNo}}</p>
            <p class="bank-name">{{item.channelName}}</p>
          </div>
          <div class="market">
            <p class="marketName">{{item.marketName}}</p>
            <p class="text">市场</p>
          </div>
          <div class="status">
            <p :class="item.status === '01' ? 'statusName green' : item.status === '04' ? 'statusName red' : 'statusName default'">{{item.status === '01' ? '启用' : '禁用'}}</p>
            <p class="text">状态</p>
          </div>
          <div class="operation">
            <span v-if="item.channelCode === '002'" @click="payment(item)">支付</span>
            <span v-if="item.channelCode === '002'" @click="recharge(item)">充值</span>
            <span v-if="item.channelCode === '001'" @click="transfer(item)">转账</span>
            <span v-if="item.channelCode === '001' || item.channelCode === '003'" @click="withdrawal(item)">提现</span>
            <span v-if="item.channelCode === '001' || item.channelCode === '003'" @click="toDetails(item)">详情</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="goodsAccountList.length">
      <div class="title">我的货款账户</div>
      <div class="content">
        <div class="item" v-for="(item, index) in goodsAccountList" :key="index">
          <div class="logo">
            <img src="@/assets/hk.png" alt="">
          </div>
          <div class="bank">
            <p class="no">{{item.exAccountNo}}</p>
            <p class="bank-name">{{item.channelName}}</p>
          </div>
          <div class="market">
            <p class="marketName">{{item.marketName}}</p>
            <p class="text">市场</p>
          </div>
          <div class="status">
            <p :class="item.status === '01' ? 'statusName green' : item.status === '04' ? 'statusName red' : 'statusName default'">{{item.status === '01' ? '启用' : '禁用'}}</p>
            <p class="text">状态</p>
          </div>
          <div class="operation">
            <span @click="hkAccess(item)">预付货款</span>
            <span @click="toDetails(item)">详情</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="CYJAccountList.length">
      <div class="title">我的诚意金账户</div>
      <div class="content">
        <div class="item" v-for="(item, index) in CYJAccountList" :key="index">
          <div class="logo">
            <img src="@/assets/hk.png" alt="">
          </div>
          <div class="bank">
            <p class="no">{{item.exAccountNo}}</p>
            <p class="bank-name">{{item.channelName}}</p>
          </div>
          <div class="market">
            <p class="marketName">{{getMarketName(item.marketId)}}</p>
            <p class="text">市场</p>
          </div>
          <div class="status">
            <p class="statusName green">启用</p>
            <p class="text">状态</p>
          </div>
          <div class="operation">
            <span @click="outMoney(item)">出金</span>
            <span @click="inMoney(item)">入金</span>
            <span @click="detail(item)">详情</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="BZJAccountList.length">
      <div class="title">我的保证金账户</div>
      <div class="content">
        <div class="item" v-for="(item, index) in BZJAccountList" :key="index">
          <div class="logo">
            <img src="@/assets/hk.png" alt="">
          </div>
          <div class="bank">
            <p class="no">{{item.matchAccountDTO.settleAccount}}</p>
            <p class="bank-name">保证金账号</p>
          </div>
          <div class="market">
            <p class="marketName">{{item.matchAccountDTO.marketName}}</p>
            <p class="text">市场</p>
          </div>
          <div class="status">
            <p :class="item.matchAccountDTO.accountStatus === 'NORMAL' ? 'statusName green': 'statusName default'">{{item.matchAccountDTO.accountStatus === 'NORMAL' ? '启用' : '禁用'}}</p>
            <p class="text">状态</p>
          </div>
          <div class="operation">
            <span @click="bzjOperate(item, 'detail')">详情</span>
            <!-- <span v-action:BZJCash @click="bzjOperate(item, 'cash')">提现</span> -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hasAccount" class="no-data">
      <img src="@/assets/blank_noData.png" />
      <p>暂无数据</p>
    </div>
    <fs-detail v-if="accShowDetail" :detailData="detailData" @done="handleClose" :title="title"></fs-detail>
    <cyj-access v-if="isCyjAccess" :payWayType="payWayType" :title="title" @done="handleClose"></cyj-access>
    <cyj-detail v-if="isCyjDetail" :detailData="cyjDetail" @done="handleClose"></cyj-detail>
    <bzjAccountDetail v-if="isBZJDetail" :row="BZJDetail" @done="handleClose"/>
  </div>
</template>
<script>
import Cookie from 'js-cookie'
import api from '@/api'
import fsDetail from './fs-detail'
import bank from '@/assets/bank.png'
import cyjAccess from '../cyj-account/cyj-access'
import cyjDetail from '../cyj-account/cyj-detail'
import bzjAccountDetail from './bzj-account/detail.vue'
export default {
  name: 'fsAccount',
  components: {
    fsDetail,
    cyjAccess,
    cyjDetail,
    bzjAccountDetail,
  },
  data () {
    return {
      title: '',
      bank: bank,
      // 列表信息
      tableData: [],
      pageSize: 10,
      // 详情
      accShowDetail: false,

      // 业务类型 203 提现 301 转账
      businessType: '301',

      // 附属账户详细信息
      transferData: '',
      detailData: {},
      marketId: Cookie.getJSON('AppUserInfo').marketCodes[0],

      // 附属户账户
      subAccountList: [],
      // 货款账户
      goodsAccountList: [],
      // 诚意金账户
      CYJAccountList: [],
      // 保证金账户
      BZJAccountList: [],
      // 渠道平台
      channelPayerBaseNo: '',
      // 银行名称
      bankName: '',
      isCyjAccess: false,
      isCyjDetail: false,
      cyjDetail: {},
      isBZJDetail: false,
      BZJDetail: {},
    }
  },
  created () {
    this.fetchList(1)
    this.getBZJ() // 获取我的保证金账户
  },
  computed: {
    hasAccount () { // 判断是否拥有账户
      return this.subAccountList.length || this.goodsAccountList.length || this.CYJAccountList.length || this.BZJAccountList.length
    }
  },
  methods: {
    // 获取保证金账户
    getBZJ () {
      const param = {
        marketCode: this.marketId,
        userAccount: this.$store.state.user.info.account,
        pageNumber: 1,
        pageSize: 10
      }
      api.myAccount.queryBZJAccount(param).then(res => {
        this.BZJAccountList = res.data.rows
      })
    },
    // 保证金详情、提现
    bzjOperate (row, type) {
      this.BZJDetail = row
      if (type === 'detail') {
        this.isBZJDetail = true // 保证金提现
      } else {
        this.$emit('done', false, row, 'bzjCash') // 保证金提现
      }
    },
    // 获取列表数据
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        // currentNo: this.currentNo,
        // pageSize: this.pageSize,
        // marketId: this.marketId,
        // baseAccountTypeList: ['SUB_ACCOUNT', 'GOODS_ACCOUNT']
        // currentNo: this.currentNo,
        // pageSize: this.pageSize,
        marketId: this.marketId,
        userAccount: this.$store.state.user.info.account,
        accountTypeList: ['SUB_ACCOUNT', 'ADVANCE_PAYMENT_ACCOUNT', 'PLATFORM_BALANCE_ACCOUNT']
      }
      let res = await api.myAccount.zbAccountList(param)
      // 诚意金
      let result = await api.myAccount.CYJAccount()
      this.CYJAccountList = result.data

      this.tableData = res.data
      this.tableData.forEach((item) => {
        switch (item.baseAccountType) {
          case 'SUB_ACCOUNT':
            this.subAccountList.push(item)
            break
          case 'GOODS_ACCOUNT':
            this.goodsAccountList.push(item)
            break
        }
      })
    },
    // 点击支付按钮
    payment () {
      this.$router.push({
        path: '/my-account/jdRecharge/payment'
      })
    },
    // 点击充值按钮
    recharge () {
      this.$router.push({
        path: '/my-account/jdRecharge/records'
      })
    },
    // 点击转账
    transfer (row) {
      this.transferData = row
      this.$emit('done', false, this.transferData, '301')
    },
    // 点击提现
    withdrawal (row) {
      this.transferData = row
      this.$emit('done', false, this.transferData, '203')
    },
    // 点击预付货款
    hkAccess (row) {
      this.transferData = row
      this.$emit('done', false, this.transferData)
    },
    // 点击详情
    async toDetails (row) {
      switch (row.baseAccountType) {
        case ('SUB_ACCOUNT'):
          this.title = '附属户详情'
          break
        case ('GOODS_ACCOUNT'):
          this.title = '货款账户详情'
          break
      }
      this.detailData = (await api.myAccount.myAccountDetail(JSON.stringify(row.baseAccountNo))).data
      this.accShowDetail = true
    },
    // 体现金额
    amount (row) {
      var f1 = parseFloat(row.amount)
      if (isNaN(f1)) {
        return false
      }
      var f2 = Math.round(row.amount * 100) / 100
      var s = f2.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return s
    },
    // 附属账户
    exAccountNo (row) {
      let channelCode = row.channelCode
      if (channelCode === '002') {
        let str = row.exAccountNo.substring(1)
        return '$' + str.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
      } else {
        return row.exAccountNo.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
      }
    },
    // 关闭弹窗
    handleClose () {
      this.accShowDetail = false
      this.isCyjDetail = false
      this.isZxDetail = false
      this.isHkDetail = false
      this.isCyjAccess = false
      this.isBZJDetail = false
    },
    // 分页
    changePage (page) {
      this.fetchList(page)
    },
    getMarketName (marketId) {
      switch (marketId) {
        case ('000'):
          return '白糖'
        case ('10606'):
          return '优选'
        default:
          return ''
      }
    },
    // 出金
    outMoney (data) {
      this.payWayType = '0'
      this.title = '诚意金出金'
      this.isCyjAccess = true
    },
    // 入金
    inMoney () {
      this.payWayType = '1'
      this.title = '诚意金入金'
      this.isCyjAccess = true
    },
    // 点击详情
    detail (row) {
      let param = {
        fundSettAccount: row.settlementAccount
      }
      api.myAccount.cyjDetail(param).then((res) => {
        this.cyjDetail = res.data
        this.isCyjDetail = true
      }).catch((err) => {
        this.$message.error(err)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .title {
    font-size: 14px;
    color: #666;
    font-family: '微软雅黑';
    margin-bottom: 25px;
  }
  .content {
    margin-bottom: 30px;
    .item {
      width: 100%;
      height: 80px;
      background: #fff;
      padding: 20px 18px;
      border-bottom: 1px solid rgb(235, 248, 245);
      .logo {
        width: 58px;
        height: 40px;
        background: #f9fafb;
        float: left;
      }
      .bank {
        width: 45%;
        height: 100%;
        margin-left: 18px;
        float: left;
        .no {
          color: #333;
          font-size: 16px;
          font-family: '微软雅黑';
        }
        .bank-name {
          color: #666;
          font-size: 12px;
          margin-top: -9px;
        }
      }
      .market {
        width: 15%;
        float: left;
        .marketName {
          color: #333;
          font-size: 16px;
          font-family: '微软雅黑';
          font-weight: bold;
        }
        .text {
          color: #666;
          font-size: 12px;
          margin-top: -9px;
        }
      }
      .status {
        width: 20%;
        height: 100%;
        float: left;
        .green {
          color: #20b37e;
          font-size: 16px;
          font-family: '微软雅黑';
          font-weight: bold;
        }
        .red {
          color: #ff5255;
          font-size: 16px;
          font-family: '微软雅黑';
          font-weight: bold;
        }
        .default {
          color: #333;
          font-size: 16px;
          font-family: '微软雅黑';
          font-weight: bold;
        }
        .text {
          color: #666;
          font-size: 12px;
          margin-top: -9px;
        }
      }
      .operation {
        span {
          display: inline-block;
          font-size: 14px;
          color: #3b88fd;
          margin: 13px 10px;
          cursor:pointer;
        }
      }
    }
  }
  .no-data {
    text-align: center;
    padding-top: 200px;
    img {
      width: 20%;
    }
    p {
      margin-top: 50px;
      font-size: 16px;
      color: #666;
      text-align: center;
    }
  }
</style>
